import { ArrowDownIcon, ArrowUpIcon, MinusIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface TrendIconProps {
  trend?: 'up' | 'down' | 'neutral'
}

const iconClassMap: Record<string, string> = {
  up: 'text-green-500',
  down: 'text-red-500',
  neutral: 'text-muted-foreground',
}

export const TrendIcon: React.FC<TrendIconProps> = ({ trend }): ReactNode => {
  const iconClass = iconClassMap[trend ?? 'neutral']

  if (trend === 'up') {
    return <ArrowUpIcon className={cn('size-3', iconClass)} />
  }
  if (trend === 'down') {
    return <ArrowDownIcon className={cn('size-3', iconClass)} />
  }
  return <MinusIcon className={cn('size-3', iconClass)} />
}
